import React from 'react';
const ActivityLongBox = (props) => (
  <div className='flex-wrap w-full p-3 mx-auto md:flex'>
    <div className='w-full bg-white rounded shadow md:box-content h-44'>
      <div className='flex w-full px-6 pt-3'>
        <div className='flex mr-2 text-xl font-medium uppercase text-summary-header'>{props.header}</div>
        {props.display && (
          <span className='text-xs pt-9px text-summary-header'>
            {props.title} {props.time}
          </span>
        )}
      </div>
      <div className='flex'>{props.children}</div>
    </div>
  </div>
);
export default ActivityLongBox;
